export default {
  REFERRAL_REQUIRED_TITLE: 'A referral is required for this patient',
  AVAILITY_EXTERNAL_PORTAL_URL: 'https://apps.availity.com',
};
